export default __webpack_public_path__ + "static/media/3.295fcf4f.txt";